var _use, _use2, _image, _image2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.227,
    cy: 33.242,
    rx: 33.227,
    ry: 33.242,
    style: {
      fill: "url(#_Linear1)"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 3.88,
    y: 17.151,
    width: "61.991px",
    height: "34.605px",
    transform: "matrix(0.999859,0,0,0.988721,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.965,32.846c6.076,-6.631 14.804,-10.791 24.496,-10.791c9.691,0 18.419,4.16 24.495,10.791c-6.076,6.631 -14.804,10.791 -24.495,10.791c-9.692,0 -18.42,-4.16 -24.496,-10.791Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 18.889,
    y: 18.265,
    width: "32.521px",
    height: "32.521px",
    transform: "matrix(0.985476,0,0,0.985476,0,0)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33.461,
    cy: 32.846,
    r: 10.246,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.965,32.846c6.076,-6.631 14.804,-10.791 24.496,-10.791c9.691,0 18.419,4.16 24.495,10.791c-6.076,6.631 -14.804,10.791 -24.495,10.791c-9.692,0 -18.42,-4.16 -24.496,-10.791Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.693,30.695c0.329,0.646 0.515,1.377 0.515,2.151c0,2.62 -2.127,4.747 -4.747,4.747c-2.621,0 -4.748,-2.127 -4.748,-4.747c0,-2.62 2.127,-4.747 4.748,-4.747c0.773,0 1.504,0.185 2.15,0.514c-0.957,0.097 -1.706,0.907 -1.706,1.89c0,1.048 0.851,1.898 1.899,1.898c0.983,0 1.792,-0.748 1.889,-1.706Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(32.9932,66.4836,-66.4836,32.9932,33.4605,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "62px",
    height: "35px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC8ElEQVRogeWZTVLDMAyF1aYnYcmaI3CEHoIjcQiOwBFYd8lJaMyCKjy/PslukgJDNeOJk9Y/nyTLirOxK8rT436zpP3z60tZay4siybGIkBb9ywMWt2vqYjF4AS7aVyzMYuoR9fFSpgNDsB45XqPAlrARdxX7eYo4WLwBLhVesZTwFmZ2lwK3w0eAG/tGwzrEXg2Jls+KqOoT+17FdAEF2sYIaNry8rqWRTYFHR0ndq1FJCCk5URekv1XuCWNbI2rAAvherTMsjgQ3CCVqAKGPvLglZrPtHSUG7PpfKACF6Cn6CVlb0M8Bz7iaKvjMbBXJTnREp1wKNpBRQzKwq+AheurYCVW18chTvBWfnsEWz9TAGV9SfwBHowDa2A2dV6oVvwUfDkeSA8KuEMficG9gEQmF3bB+PgooARHNtG0Ap8tNoYrV3kSH2PPO5gVlmb3dqLP8OOvByhRMHGB1VKMPqd/9ujyCweVPJwd29v74fK4mztwb48AtcWWjddTzy53sTi6XGPt0VARQrIdhjj/2+EtR14Z9/WRujIwrMyqJYkGWPkmf4/n+vHqeB8J4tHnbK1s71zVWAX7488YYQ6eiqybE9zco4Rfi+4biOJsqkzl7vmwQH03VrvZh2peA941PHZelp64pJJkD5HgaxpAHd1DyLsyipxcBfCzifXc5f8wTWulqTPKYxBaCmO6L8V1dmCvdmkmqcHNQzG5fn1pXAC4w1QOFri8mCXC9cfBadMskQmsjbuPNHuUymeU1aVrv5E5qas3ILmZYhzUltuMXhhURY3O7d6OcHzpHy9e/3P5+o8kJktfjvza4/Vsy0osnYGzND9b2cJfKQAlTTwXsuTuxTcRB3br/M+jnKTJzAu//nMbYh+MDN7ez/Yw9290ng0IXzOdZYo6+KxVO7QyiGWnbKiCOub/edzdZTkO1lvFG6Np7woK1Obq31JQen4UBgBq3ZZEMxygVnAPPhsubmvpUpu6vt4JGu8m1/zYOMTJWtnNFkKgVgAAAAASUVORK5CYII="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "33px",
    height: "33px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACRklEQVRYhbVYu3XDMAw8/TKIS9ceISNkiIyUITJCRnDt0oMklpQiAn06AhTlJHyPjxJFAscjAIJqsKO8Pr80tWPfPt7n2rFVQkV59Dx7zzVgiiBIObdenwKYqW/eAhOCEAANgJaeuXrKrU4MJgKSgXCUGwCrCkhBTNRO9D5HQFoPmSjvltoDGAA8VdRhGW9zE2jPuFcdywAPgFbdGt2CMaiJFWakEwDGjseA1/JqrUbbxWU+HY7N+XpJCpUZZsEU2TYMAsCrg4xnsCtwtvCeXtQIlQUWZMKyFeJujPqdjXblvr0M1K1gNnoHgHpHyX3VU0b72Igt8OqV0oxOR5G1bKA3AF8APpf2a+kzQ01M6AoMUIs8RkQGp33tAobZHR1ds26HBia1gZLFe2AUgMpKg4AcXSk87ylb8hoGsTUJ2AfGmxcuqpWJKug/S7YdwPo49t7/uiT5rXR4x7F+q1VQKzOziWjCo6yU5CWZvTOB8wBzKw3DJXvRE9XkaH6RSu9M5GjXYX0WeN7EyqPFMJCMje58veB0OJbcqRSqlQFrWfGIe6jmcD0BP7mnRkxbMUe3G33vcA/FmuB6AFgxJzYTT+oAYGGD+zWgsMLIyHT1fHgxkCy7UibUJpQlY8EyKC/RNUWmWLch87aU3oltaIlWHeWTN8Rbkd1DopTfS/U5yd1K+Rlclvpr2p+l/MsAL3Pm5GSrhnag+lwmhBEb47lrxIR3AyteBYsnZeEuWvIcBpT6HrqLOkB0jpdNZ8+/vpVXAArLnv8T38jSYYjpbaw0AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.4579,66.4836,-66.4836,33.4579,22.3175,2.27374e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.6c13fae8fa66ebc832670438225cc9b8.svg";
export { ForwardRef as ReactComponent };